export default "__VITE_ASSET__Ux8y7y80__"